import axios from 'axios'
const Tracking = (event)=> {
    let data = {    
        "event": event
    }
    axios.post('/api/track', data).then(res => { 
      console.log(res)
    })
    .catch(error => {
      console.log(error);
    });

}

export default Tracking



// WEBPACK FOOTER //
// ./components/tracking.js